module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"payTitulo":"DCC service","payText":"This service allows foreign customers to pay in their home currency.","payBtn":"MORE INFORMATION"},"es":{"payTitulo":"Servicio DCC","payText":"Es un servicio que permite al cliente extranjero pagar en su divisa de origen.","payBtn":"MÁS INFORMACIÓN"}}')
  delete Component.options._Ctor
}
